<template>
    <div class="flex-1 p-8">
        <section class="panel flex flex-col">
            <page-header icon="email-forbidden-stroke" label="Manage Email Blacklist">
                <a :href="route('admin.dashboard')" class="button-icon button-sm">
                    <app-icon name="close"></app-icon>
                </a>
            </page-header>

            <infinite-data-table
                ref="table"
                class="-mx-8 md:mx-0 text-gray-600"
                column-header-class="z-10"
                :columns="columns"
                :filter="filter"
                no-results-placeholder="We couldn't find any blacklisted emails matching the filtering criteria."
                :source="source"
            >
                <template #header>
                    <div class="flex-auto">
                        <search-field
                            v-model="filter.term"
                            class="w-full md:w-80"
                            placeholder="Search by domain..."
                        ></search-field>
                    </div>

                    <div class="flex justify-end flex-auto ml-4">
                        <button
                            class="button-icon button-primary button-lg"
                            @click="isNewBlacklistedEmailModalVisible = true"
                        >
                            <app-icon name="add-circle" stroke></app-icon>
                        </button>
                    </div>
                </template>

                <template #row="{ property, row, value }">
                    <template v-if="property === 'enabled'">
                        <toggle-switch
                            :value="value"
                            small
                            @input="newValue => update(row, { enabled: newValue })"
                        ></toggle-switch>
                    </template>

                    <template v-else-if="property === 'hard_ban'">
                        <toggle-switch
                            :value="value"
                            small
                            @input="newValue => update(row, { hard_ban: newValue })"
                        ></toggle-switch>
                    </template>

                    <template v-else>{{ value }}</template>
                </template>
            </infinite-data-table>
        </section>

        <app-modal v-model="isNewBlacklistedEmailModalVisible">
            <template #header>Add Email to Blacklist</template>

            <template #default="{ close }">
                <form id="email-form" @submit.prevent="store(close)">
                    <form-field-wrapper label="Domain" :error="form.errors.get('value')">
                        <input
                            v-model="form.value"
                            class="form-field"
                            placeholder="Domain"
                        >
                    </form-field-wrapper>

                    <form-field-wrapper label="Hard Ban" :error="form.errors.get('hard_ban')">
                        <toggle-switch v-model="form.hard_ban"></toggle-switch>
                    </form-field-wrapper>
                </form>
            </template>

            <template #footer="{ close }">
                <stateful-button
                    class="button-primary"
                    form="email-form"
                    :loading="form.processing"
                    type="submit"
                >
                    Add
                </stateful-button>

                <button class="button" @click="close">Cancel</button>
            </template>
        </app-modal>
    </div>
</template>

<script>
import axios from '@/util/axios';
import Form from '@/validation/Form';

export default {
    data () {
        return {
            filter: {
                term: ''
            },
            form: new Form({
                value: '',
                hard_ban: true
            }),
            isNewBlacklistedEmailModalVisible: false
        };
    },

    computed: {
        columns () {
            return [
                {
                    label: 'Domain',
                    property: 'value',
                    desktop: true
                },
                {
                    label: 'Enabled',
                    property: 'enabled',
                    desktop: true
                },
                {
                    label: 'Hard Ban',
                    property: 'hard_ban',
                    desktop: true
                }
            ];
        },

        source () {
            return this.route('api.admin.blacklist.emails.index');
        }
    },

    methods: {
        store (closeFunction) {
            this.form.post(this.route('api.admin.blacklist.emails.store'))
                .then(() => {
                    closeFunction();

                    this.$refs.table.reload();
                })
                .catch(() => {
                    this.$toasted.global.error('There was an error adding a domain to the blacklist.');
                });
        },

        update (blacklistedEmail, data) {
            axios.patch(this.route('api.admin.blacklist.emails.update', blacklistedEmail), data)
                .then(() => {
                    this.$refs.table.reload();
                })
                .catch(() => {
                    this.$toasted.global.error('There was an error updating the blacklist.');
                });
        }
    }
};
</script>
